import { useEffect } from 'react';
import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TituloH2 = ({ classes, text }) => {
  useEffect(() => {
    const titulosh2 = gsap.utils.toArray('.title-h2-js');

    titulosh2.forEach((elem) => {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          y: 10
        },
        {
          scrollTrigger: {
            trigger: elem,
            start: 'top bottom'
            // markers: true
          },
          autoAlpha: 1,
          y: 0,
          delay: 0.5
        }
      );
    });
  }, []);

  return <h2 className={cn(classes, 'title-h2-js')}>{text}</h2>;
};
export default TituloH2;
